import { oidcConfig } from "@/lib/api";

function base64Url(bytes) {
  return btoa(String.fromCharCode(...new Uint8Array(bytes)))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

export function randomUrlSafe(n = 32) {
  const v = new Uint8Array(n);
  crypto.getRandomValues(v);
  return base64Url(v.buffer);
}

export async function createPkce() {
  const codeVerifier = randomUrlSafe(32);
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(codeVerifier));
  return { codeVerifier, codeChallenge: base64Url(digest) };
}

export async function startSocialPulseLogin() {
  const cfg = await oidcConfig();
  const clientId = cfg.client_id || "websitetech-web";
  const authEndpoint = cfg.authorization_endpoint;
  if (!authEndpoint) throw new Error("SSO temporarily unavailable");

  const { codeVerifier, codeChallenge } = await createPkce();
  const state = randomUrlSafe(32);
  const nonce = randomUrlSafe(32);
  const redirectUri = `${window.location.origin}/auth/socialpulse-callback`;

  sessionStorage.setItem("oidc.state", state);
  sessionStorage.setItem("oidc.nonce", nonce);
  sessionStorage.setItem("oidc.code_verifier", codeVerifier);
  sessionStorage.setItem("oidc.redirect_uri", redirectUri);

  const url = new URL(authEndpoint);
  url.search = new URLSearchParams({
    response_type: "code",
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: "openid profile email",
    state,
    nonce,
    code_challenge: codeChallenge,
    code_challenge_method: "S256",
  }).toString();
  window.location.assign(url.toString());
}
